module.exports = __webpack_public_path__ + "static/chris-a72c0daaf8458b1f24d3efa1b7e74900.png";